<app-dialog-wrapper>
  <div class="modal-charset">
    <div class="image-card">
      <img src="{{symptoms.image}}" alt={{symptoms.title}}>
      <p>{{symptoms.title}}</p>
    </div>
    @for(item of symptoms.moreInfo;track item){
    <ul class="charset-list-container">
      <li>
        <p class="question">{{item.question}}</p>
      </li>
      <li>
        <p>{{item.answer}}</p>
      </li>
    </ul>
    }
  </div>
</app-dialog-wrapper>
